export const CVAPP_PEOPLE_COUNT_EE = "People Counting Entry/Exit";
export const CVAPP_PEOPLE_COUNT_OA = "People Counting Fixed Area";
export const CVAPP_SLIPANDFALL = "Slip And Fall";
export const CVAPP_DWELLTIME = "Dwell Time";
export const CVAPP_ENTRYEXIT = "Entry Exit";
export const CVAPP_VEHICLECOUNTOA = "Vehicle Counting Fixed Area";
export const CVAPP_VEHICLECOUNTEE = "Vehicle Counting Entry/Exit";
export const CVAPP_OPENDOOR = "Open Door Detection";
export const CVAPP_PPEUSAGE = "Missing Personal Protective Equipment";
export const CVAPP_OBJECTDETECTION = "Object Detection";
export const CVAPP_UNOBJECTDETECTION = "Unattended Object Detection";
export const CVAPP_PROXIMITY = "Proximity Detection";
export const CVAPP_CROWDDENSITY = "Crowd counting";
export const CVAPP_CAMERAADJUSTMENT = "Stream Monitoring";
export const CVAPP_OBJECTBLUR = "Object Blurring";
export const CVAPP_PARKINGOCCUPANCYOA = "Parking Occupancy Fixed Area";
export const CVAPP_PARKINGOCCUPANCYEE = "Parking Occupancy Entry/Exit";
export const CVAPP_PARKINGOCCUPANCYEE_FULLNAME = "Parking Occupancy Entry/Exit";
export const CVAPP_PEOPLE_COUNT_EE_FULLNAME = "People Counting Entry/Exit";
export const CVAPP_VEHICLECOUNTEE_FULLNAME = "Vehicle Counting Entry/Exit";
export const CVAPP_PERSON_DETECTION = "Person Detection";
export const CVAPP_VEHICLE_DETECTION = "Vehicle Detection";
export const CVAPP_WATERLEAK_DETECTION = "WaterLeak Detection";

export const eventTriggerTexts = {
  [CVAPP_PEOPLE_COUNT_OA]: "People count is:",
  [CVAPP_PEOPLE_COUNT_EE]: "People count is:",
  [CVAPP_SLIPANDFALL]: "Slip and fall is detected.",
  [CVAPP_DWELLTIME]: "Longest active dwell time is:",
  [CVAPP_ENTRYEXIT]: "People count is:",
  [CVAPP_VEHICLECOUNTOA]: "Vehicle count is:",
  [CVAPP_VEHICLECOUNTEE]: "Vehicle count is:",
  [CVAPP_OPENDOOR]: "Door is opened.",
  [CVAPP_PPEUSAGE]: "Missing personal protective equipment.",
  [CVAPP_OBJECTDETECTION]: "The selected object or objects are detected.",
  [CVAPP_UNOBJECTDETECTION]: "Selected object(s) left unattended.",
  [CVAPP_PROXIMITY]: "Proximity event.",
  [CVAPP_CROWDDENSITY]: "Crowd density is:",
  [CVAPP_CAMERAADJUSTMENT]: "Camera position is adjusted or moved.",
  [CVAPP_OBJECTBLUR]: "Object is blurred.",
  [CVAPP_PARKINGOCCUPANCYOA]: "Parking occupancy is:",
  [CVAPP_PARKINGOCCUPANCYEE]: "Parking occupancy is:",
  [CVAPP_VEHICLE_DETECTION]: "Vehicle is detected.",
  [CVAPP_PERSON_DETECTION]: "Person is detected.",
  [CVAPP_WATERLEAK_DETECTION]: "Water leak detected.",
};
export const CV_APP_TYPE_EVENT = "event";
export const CV_APP_TYPE_ANALYTICS = "analytics";
export const CV_APP_TYPE_EE = "entry_exit";
export const CV_APP_TYPE_OA = "fixedarea";

export const CVAPP_VEHICLE_KEYWORD = "vehicle";
export const CVAPP_ENTRY_EXIT_KEYWORD = "Entry/Exit";

export const CVAPP_TOOLTIP_PEOPLE_EE =
  "Used to define the occupancy of a sub-area, area, floor or site by marking how many people cross into and out of the entry/exit points of these locations.";
export const CVAPP_TOOLTIP_VEHICLE_EE =
  "Used to define the occupancy of a sub-area, area, floor or site by marking how many vehicles cross into and out of the entry/exit points of these locations.";
export const CVAPP_TOOLTIP_PEOPLE_OA =
  "Used to determine how many people are in a user-defined polygon in view of a single stream.";
export const CVAPP_TOOLTIP_VEHICLE_OA =
  "Used to determine how many vehicles are in a user-defined polygon in view of a single stream.";
